module.exports = __webpack_public_path__ + "img/home_content_bg_vip.86d9436c.png";